export default defineNuxtPlugin((nuxtApp) => {
  const print = (content: string) => {
    const styles = document.getElementsByTagName('style')

    const head = [...styles].map((style) => {
      return style.outerHTML
    }).join('')

    const page = window.open('about:blank', 'print_preview')

    if (!page) return

    page.document.write(`
        <!DOCTYPE html>
          <html>
            <head>
              ${head}
              <style>
                html {
                  overflow-x: visible;
                  overflow-y: visible;
                }

                body {
                  pointer-events: none
                }

                ::-webkit-scrollbar {
                  display: none;
                }
              </style>
            </head>
            <body>${content}</body>
          </html>
        `)

    setTimeout(() => {
      page.document.close()

      page.focus()
      page.print()
    }, 1000)
  }

  nuxtApp.provide('print', print)
})
